import React, { Component } from 'react'
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import moment from 'moment';
import SwalServices from '../../../services/swalServices/SwalServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class OpeningStock extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
        }
    }

    getPinnedWidth = (key) => {
        const pinnedCol = {
            "srNo": window.innerWidth * 0.03,
            "Select": window.innerWidth * 0.04,
            "drawingNo": window.innerWidth * 0.12,
            "itemCategory": window.innerWidth * 0.1,
            "itemName": window.innerWidth * 0.15,
        }
        return pinnedCol[key]
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                // this.getMasterExpenseAccGroupCount();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Opening stock",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            idPlant: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];

                    if (data.length > 0) {
                        data.map((x, key) => {
                            x.srNo = key + 1;
                            x.Select = x.isStockUpdated; // Pre-select first row
                            x.opStockDate = moment(x.opStockDate).format("DD-MM-YYYY");
                        });

                        const columnPriority = [
                            "srNo", "Select", "drawingNo", "itemCategory", "itemName",
                            "unitDescription", "opStockDate", "opStock", "rejectionStock",
                            "status", "isApproved",
                        ];

                        const allKeys = Object.keys(data[0]);
                        const sortedKeys = allKeys.sort((a, b) => {
                            const indexA = columnPriority.indexOf(a);
                            const indexB = columnPriority.indexOf(b);
                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                        });

                        const dynamicColDefs = sortedKeys.map((key) => {
                            const isCheckboxCol = key === "Select" || key === "isApproved";

                            return {
                                field: key.includes(".") ? key.replace(/\./g, "_") : key,
                                headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() +
                                    key.replace(/([A-Z])/g, ' $1').slice(1),
                                minWidth: this.getColumnWidth(key) !== undefined
                                    ? this.getColumnWidth(key)
                                    : window.innerWidth * 0.06,
                                flex: 1,
                                filter: true,
                                floatingFilter: true,
                                hide: ["idItem", "isStockUpdated", "closingStock", "fixOpStock", "fixOpStockDate"].includes(key),
                                width: this.getPinnedWidth(key),
                                valueGetter: (params) => params.data[key],
                                pinned: ["srNo", "Select", "drawingNo", "itemCategory", "itemName"].includes(key) ? "left" : null,
                                ...(isCheckboxCol && {
                                    cellRenderer: 'agCheckboxCellRenderer',
                                    editable: true,
                                }),
                            };
                        });

                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                        }, () => {
                            this.setPermissions(permissions);
                        });
                    }
                } else {
                    this.setPermissions(permissions);
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    // getMasterItemSelectForItemStock = () => {
    //     let request = [this.state.idCompany, 0];

    //     this.masterEntryServices.getMasterItemSelectForItemStock(request).then((response) => {
    //         if (response.statusCode == 200 && response.responseItem !== null) {
    //             let data = response.responseItem.responseContent;

    //             if (data.length > 0) {
    //                 data.map((x, key) => {
    //                     x.srNo = key + 1;
    //                     x.Select = x.isStockUpdated; // Pre-select first row
    //                     x.opStockDate = moment(x.opStockDate).format("DD-MM-YYYY");
    //                 });

    //                 const columnPriority = [
    //                     "srNo", "Select", "drawingNo", "itemCategory", "itemName",
    //                     "unitDescription", "opStockDate", "opStock", "rejectionStock",
    //                     "status", "isApproved",
    //                 ];

    //                 const allKeys = Object.keys(data[0]);
    //                 const sortedKeys = allKeys.sort((a, b) => {
    //                     const indexA = columnPriority.indexOf(a);
    //                     const indexB = columnPriority.indexOf(b);
    //                     if (indexA === -1 && indexB === -1) return 0;
    //                     if (indexA === -1) return 1;
    //                     if (indexB === -1) return -1;
    //                     return indexA - indexB;
    //                 });

    //                 const dynamicColDefs = sortedKeys.map((key) => {
    //                     const isCheckboxCol = key === "Select" || key === "isApproved";

    //                     return {
    //                         field: key.includes(".") ? key.replace(/\./g, "_") : key,
    //                         headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() +
    //                             key.replace(/([A-Z])/g, ' $1').slice(1),
    //                         minWidth: this.getColumnWidth(key) !== undefined
    //                             ? this.getColumnWidth(key)
    //                             : window.innerWidth * 0.06,
    //                         flex: 1,
    //                         filter: true,
    //                         floatingFilter: true,
    //                         hide: ["idItem", "isStockUpdated", "closingStock", "fixOpStock", "fixOpStockDate"].includes(key),
    //                         width: this.getPinnedWidth(key),
    //                         valueGetter: (params) => params.data[key],
    //                         pinned: ["srNo", "Select", "drawingNo", "itemCategory", "itemName"].includes(key) ? "left" : null,
    //                         ...(isCheckboxCol && {
    //                             cellRenderer: 'agCheckboxCellRenderer',
    //                             editable: true,
    //                         }),
    //                     };
    //                 });

    //                 this.setState({
    //                     rowData: data,
    //                     colDefs: dynamicColDefs,
    //                 });
    //             }
    //         }
    //     });
    // };

    getColumnWidth = (key) => {
        const colwidth = {
            "unitDescription": window.innerWidth * 0.06,
            "opStockDate": window.innerWidth * 0.08,
            "opStock": window.innerWidth * 0.04,
            "rejectionStock": window.innerWidth * 0.04,
            "status": window.innerWidth * 0.06,
            "Approved": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    adminApproved = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.approve);
            return;
        }
        let request = [];
        let data = this.state.rowData;
        data.map((x) => {
            if (x.isApproved === true) {
                request.push(x.idItem);
            }
        });
        if (request.length > 0) {
            this.masterEntryServices.masterItemStockAdminApproved(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    this.SwalServices.Success("Approved successfully.");
                    this.procSelectAllRecordsSP();
                }
            });
        }
    }

    save = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.save);
            return;
        }
        let request = [];
        let data = this.state.rowData;
        // debugger;
        data.map((x) => {
            if (x.Select === true) {
                let obj = {
                    idItem: x.idItem,
                    opStock: x.opStock,
                    fpStock: x.fixOpStock,
                    rejectionStock: x.rejectionStock,
                    opStockDate: (x.opStockDate && x.opStockDate !== 'Invalid date') ? moment(x.opStockDate, "DD-MM-YYYY").toDate() : null,
                    idUser: this.state.idUser,
                };
                request.push(obj);
            }
        });
        if (request.length > 0) {
            this.masterEntryServices.saveAndUpdateStock(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    this.SwalServices.Success("Save successfully.");
                    this.procSelectAllRecordsSP();
                }
            });
        }
    }

    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>

                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 208px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item stock register</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    headerHeight={65}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>

                        </div>
                        <div className="btn-grp inline-flex gap-2.5 mt-5">
                            <button className="update-btn btns" onClick={() => this.save()}>
                                Save
                            </button>
                            <button className="save-btn btns" onClick={() => this.adminApproved()}>Admin approve</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
